// @flow

import styled from 'styled-components';
import { theme } from '../theme';

export const HighlightBox = styled.div`
  background-color: ${props => props.outline ? 'white' : 'hsla(240,8%,51%,0.05)'};
  border-color: ${props => props.bordered ? theme.colors.gray(87) : 'transparent'};
  border-radius: 5px;
  border-style: solid;
  border-width: 0.1em;
`;
